module.exports = __webpack_public_path__ + "assets/img/Type BS (19).ba070765.jpg";